import { AxiosError } from "axios";
import { BoardSettingsModel } from "models/BoardSettingsModel";
import { createContext } from "react";

export interface IBoardSettingsContext {
  boardSettings: BoardSettingsModel | undefined;
  error?: AxiosError;
  isLoading: boolean;
  reloadBoardSettings: () => Promise<void>;
}

export const BoardSettingsContext = createContext({} as IBoardSettingsContext);
